import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Chatmessage
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { t, t2 } from '@/@core/libs/i18n/utils'
import { $themeConfig } from '@themeConfig'

export default function useChatmessageList() {
  // Use toast
  const toast = useToast()

  const refChatmessageListTable = ref(null)
  const lineOa = computed(() => store.state.lineapi.lineOa)

  const msgChatmessageList = {
    errorfetch: t2('Error fetching {module} list', { module: t('Chatmessage') }),
    id: `${t('Type')} » ${t('ID')}`,
    message: `${t('Chat Message')}`,
    actions: t('Actions'),
  }

  // Table Handlers
  const tableColumns = [
    { key: 'id', sortable: true, label: msgChatmessageList.id },
    { key: 'message', sortable: false, label: msgChatmessageList.message },
    { key: 'actions', label: msgChatmessageList.actions },
  ]

  const filterList = JSON.parse(localStorage.getItem(`${$themeConfig.app.session}-filter-chatmessage-list`))

  const perPage = ref((filterList != null && filterList.perPage != null) ? filterList.perPage : 10)
  const totalChatmessages = ref(0)
  // const currentPage = ref((filterList != null && filterList.page != null) ? filterList.page : 1)
  const currentPage = ref(1)
  const perPageOptions = [2, 5, 10, 25, 50, 100]
  const searchQuery = ref((filterList != null && filterList.q != null) ? filterList.q : '')
  const sortBy = ref((filterList != null && filterList.sortBy != null) ? filterList.sortBy : 'id')
  const isSortDirDesc = ref((filterList != null && filterList.sortDesc != null) ? filterList.sortDesc : true)
  const locale = ref('th')

  const dataMeta = computed(() => {
    const localItemsCount = refChatmessageListTable.value ? refChatmessageListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalChatmessages.value,
    }
  })

  const refetchData = () => {
    if (refChatmessageListTable.value !== null) {
      refChatmessageListTable.value.refresh()
    }
  }

  watch([currentPage, perPage, searchQuery, locale], () => {
    refetchData()
  })

  const getListChatmessage = (ctx, callback) => {
    const { id } = JSON.parse(lineOa.value)
    const params = {
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      language: locale.value,
      lineOaId: id,
    }
    store
      .dispatch('chatmessage-store/getListChatmessage', params)
      .then(response => {
        const { list, total } = response.data
        callback(list)
        totalChatmessages.value = total
        localStorage.setItem(`${$themeConfig.app.session}-filter-chatmessage-list`, JSON.stringify(params))
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: msgChatmessageList.errorfetchChatmessage,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        },
        {
          position: 'bottom-right',
        })
      })
  }

  return {
    getListChatmessage,
    tableColumns,
    perPage,
    currentPage,
    totalChatmessages,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    locale,
    refChatmessageListTable,
    filterList,

    refetchData,
  }
}
